"use client";
import React from "react";
import { TurnrTableCell, TurnrTableRow } from "~/components/table/TurnrTableSmart.jsx";
import { ENTITY_TYPE } from "~/constants";
import { getTableHeadActions, TableCellActions } from "~/components/table/cells/TableCellActions.jsx";
import { COLORS } from "rylak-common/src/constants";
import EntityActionsDotsMenu from "~/components/entityAction/EntityActionsDotsMenu.jsx";
import { getTableHeadDateTime, TableCellDateTime } from "~/components/table/cells/TableCellDateTime.jsx";
import EntityActionFilterForm from "~/components/entityAction/EntityActionFilterForm.jsx";
import { TableCellId } from "~/components/table/cells/TableCellId.jsx";

const tableHeadData = {
    items: [
        {
            id: "name",
            label: "Name",
            sortable: true,
            defaultSortedBy: true,
        },
        getTableHeadDateTime({ hide: "xs" }),
        {
            id: "ingridMerchantId",
            label: "Ingrid Merchant Id",
            sortable: false,
            hide: "sm",
            description: "ID used to connect different Ingrid products across domains",
        },
        getTableHeadActions(),
    ],
};

function TableContent({ appProps, entitiesPaginatedService, reFetchEntitiesPaginated, ...rest }) {
    return entitiesPaginatedService?.data?.content?.map((shopGroup) => {
        return (
            <TurnrTableRow key={shopGroup?.id} {...rest}>
                <TurnrTableCell fullWidth={true} tight>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: "20px",
                            textWrap: "nowrap",
                        }}
                    >
                        <div>
                            <div>{shopGroup?.name}</div>
                            <div style={{ fontSize: "10px", textWrap: "nowrap", color: COLORS.WEAK_TEXT }}>{shopGroup?.displayName}</div>
                        </div>
                    </div>
                </TurnrTableCell>
                <TableCellDateTime dateTime={shopGroup?.createdAt} />
                <TableCellId fullWidth={true} id={shopGroup?.ingridMerchantId} />
                <TableCellActions>
                    <EntityActionsDotsMenu hideIfEmpty={true} appProps={appProps} onSuccess={reFetchEntitiesPaginated} entity={shopGroup} />
                </TableCellActions>
            </TurnrTableRow>
        );
    });
}

export default function AdminPageShopGroupCard({ appProps }) {
    return (
        <EntityActionFilterForm appProps={appProps} entityType={ENTITY_TYPE.SHOP_GROUP} tableHeadData={tableHeadData}>
            <TableContent appProps={appProps} />
        </EntityActionFilterForm>
    );
}
